import React, { useEffect, useState, useCallback, useRef } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios-backend";
import BackButton from "../../main/BackButton";
import ClickHere from "../../main/ClickHere";
import Line from "../../main/Line";
import SwiperSlider from "../../main/SwiperSlider";
import Text from "../../main/Text";
import classes from "../css/Authentication.module.css";
import { LazyImageWithLoader } from "../LazyImageWithLoader";

// const IMG_W = 800;
// const IMG_H = 500;

const ShowingCard = () => {
  const navigate = useNavigate();
  const [images, setImages] = useState([]);
  const [email, setEmail] = useState("");
  const [authPortalText, setAuthPortalText] = useState("");
  const mountedRef = useRef(true);

  const buildSrc = (u) =>
    u?.startsWith("s3")
      ? `https://wonwonleywon-images.s3.amazonaws.com/product_images/${u}`
      : `${process.env.REACT_APP_Url}${u}`;

  const getData = useCallback(async () => {
    if (!sessionStorage["isAuth"]) {
      navigate("/home");
      return;
    }

    try {
      const cardRes = await axios.get("/authenticationcard/", {
        params: {
          cardNumber: sessionStorage["cardNumber"],
          password: sessionStorage["password"],
        },
      });

      const card = cardRes?.data;
      if (card?.status !== 200) {
        navigate(-1);
        return;
      }

      sessionStorage["transfer"] = card.id;

      const imgsRes = await axios.get("/get-imgs-by-pid", {
        params: { id: card.id, type: 2 },
      });

      if (!mountedRef.current) return;

      setImages(Array.isArray(imgsRes?.data?.imgs) ? imgsRes.data.imgs : []);
      setEmail(card.email || "");
      setAuthPortalText(card.authPortalText || "");
    } catch {
      navigate(-1);
    }
  }, [navigate]);

  useEffect(() => {
    mountedRef.current = true;
    getData();
    return () => {
      mountedRef.current = false;
    };
  }, [getData]);

  const handleTransfer = () => navigate(`/authenticity/transfer`);

  return (
    <>
      <BackButton />

      <div className="singleContainer">
        <SwiperSlider>
          {images.map((i, index) => {
            const src = buildSrc(i?.url);
            const isFirst = index === 0;

            return (
   <LazyImageWithLoader
  key={i?.id || i?.url || index}
  src={src}
  alt={`Product image ${index + 1}`}
  className="singleImg"
 style={{
                      minHeight: "300px",
                      maxHeight: "500px",
                      minWidth: "300px",
                      maxWidth: "500px",
                      padding: "10px 0",
                    }}
  fetchPriority={isFirst ? "high" : "low"}
/>


            );
          })}
        </SwiperSlider>
      </div>

      <Line type="top-line">the owners email address of this product is:</Line>
      <Line type="top-line">{email}</Line>
      <Line type="top-line">
        transfer ownership <ClickHere onClick={handleTransfer} />
      </Line>

      {/* ✅ simpler + avoids map-without-keys */}
      <Text className={classes.text} style={{ whiteSpace: "pre-line" }}>
        {authPortalText}
      </Text>
    </>
  );
};

export default ShowingCard;
